import { Fragment } from 'react';

import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { NsList } from 'components/common/ns-list/NsList';
import { actionUrl } from 'config/static-content';
import { HELP_CONTACT_NUMBER } from 'config/app-config';

export const testId = 'meterReadContactErrorTestId';

type ErrorComponentProps = {
  title?: string;
};

const ErrorComponent = ({ title }: ErrorComponentProps) => {
  return (
    <NsAlert state="error" heading={title} testId={testId}>
      <p>
        To ensure a hassle-free experience during your move in, please get in
        contact with us.
      </p>
      <NsList>
        {[
          <Fragment key={0}>
            <NsAnchor href={actionUrl.contact}>Live chat</NsAnchor>, Monday to
            Friday, 8am-8pm and Saturday 9am-5pm.
          </Fragment>,
          <Fragment key={1}>
            Call us on{' '}
            <NsAnchor href={`tel:${HELP_CONTACT_NUMBER.MOVE_IN}`}>
              {HELP_CONTACT_NUMBER.MOVE_IN_LABEL}
            </NsAnchor>
            , Monday to Friday, 8am-6pm.
          </Fragment>
        ]}
      </NsList>
    </NsAlert>
  );
};

const MeterReadMaxAttemptsError = ErrorComponent;
const MeterReadAgentHandOffError = ErrorComponent;

export { MeterReadMaxAttemptsError, MeterReadAgentHandOffError };
